import orderRoutes from './order.routes';

import orderSaveController from './controllers/order.save.controller';
import orderFormController from './controllers/order.form.controller';
import orderRefundController from './controllers/order.refund.controller';
import orderSummaryController from './controllers/order.summary.controller';
import orderListController from './controllers/order.list.controller';
import orderNotesController from './controllers/order.notes.controller';
import refundHistoryController from './controllers/refund.history.controller';
import statusesController from './controllers/statuses.controller';
import adminPaymentErrorsController from './controllers/admin.payment.errors.controller';
import orderEmailsController from './controllers/order.emails.controller';
import emailViewController from './controllers/email.view.controller';

import orderSaveComponent from './components/order.save.component';
import orderFormComponent from './components/order.form.component';
import orderRefundComponent from './components/order.refund.component';
import orderSummaryComponent from './components/order.summary.component';
import orderListComponent from './components/order.list.component';
import orderNotesComponent from './components/order.notes.component';
import refundHistoryComponent from './components/refund.history.component';
import orderStatusesComponent from './components/order.statuses.component';
import paymentStatusesComponent from './components/payment.statuses.component';
import adminPaymentErrorsComponent from './components/admin.payment.errors.component';
import emailViewComponent from './components/email.view.component';
import orderEmailsComponent from './components/order.emails.component';

import ordersApiService from './services/orders.api.service';
import refundService from './services/refund.service';

let orderModule = angular.module('spabooker.order', ['spabooker.base'])
    .config(orderRoutes)

    .controller('orderSaveController', orderSaveController)
    .controller('orderFormController', orderFormController)
    .controller('orderRefundController', orderRefundController)
    .controller('orderSummaryController', orderSummaryController)
    .controller('orderListController', orderListController)
    .controller('orderNotesController', orderNotesController)
    .controller('refundHistoryController', refundHistoryController)
    .controller('statusesController', statusesController)
    .controller('adminPaymentErrorsController', adminPaymentErrorsController)
    .controller('orderEmailsController', orderEmailsController)
    .controller('emailViewController', emailViewController)

    .component('orderSave', orderSaveComponent)
    .component('orderForm', orderFormComponent)
    .component('orderRefund', orderRefundComponent)
    .component('orderSummary', orderSummaryComponent)
    .component('orderList', orderListComponent)
    .component('orderNotes', orderNotesComponent)
    .component('refundHistory', refundHistoryComponent)
    .component('orderStatuses', orderStatusesComponent)
    .component('paymentStatuses', paymentStatusesComponent)
    .component('adminPaymentErrors', adminPaymentErrorsComponent)
    .component('emailView', emailViewComponent)
    .component('orderEmails', orderEmailsComponent)

    .factory('ordersApiService', ordersApiService)
    .factory('refundService', refundService)
    ;

export default orderModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/index.js